import { render, staticRenderFns } from "./EventsBiddingList.vue?vue&type=template&id=22cb0818&scoped=true"
import script from "./EventsBiddingList.vue?vue&type=script&lang=js"
export * from "./EventsBiddingList.vue?vue&type=script&lang=js"
import style0 from "./EventsBiddingList.vue?vue&type=style&index=0&id=22cb0818&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cb0818",
  null
  
)

export default component.exports